import { getPotentialResources, getQueriesFromString } from './queries';

function sortByPopularity(a, b) {
  if (a.p[0][0] < b.p[0][0]) return 1;
  if (a.p[0][0] > b.p[0][0]) return -1;
  return 0;
}

export default function searchResultsReducer(state, action) {
  if (action.type === 'INITIAL_SETUP') {
    return {
      ...state,
      results: state.resources,
    };
  } else if (action.type === 'ACTIVATE_RESOURCE_SEARCH'
    || action.type === 'UPDATE_RESOURCE'
    || action.type === 'ADD_RESOURCE') {
    const query = action.searchText || state.resourceSearchText;
    if (!action.results) {
      return {
        ...state,
        results: getPotentialResources({
          state,
          queries: getQueriesFromString(query),
        }).sort(sortByPopularity),
      };
    }
    return {
      ...state,
      results: action.results.sort(sortByPopularity),
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/results.js